module.exports = __webpack_public_path__ + "img/idcardPositive.60e9614f.png";